import {Component, OnInit} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {AppService} from './app.service';
import {backGroundEnum} from './js/backGroundEnum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
/**
 * The about AppComponent
 *
 */
export class AppComponent implements OnInit {
  /**
   * constructor
   */
  constructor(private router: Router,
              public appService: AppService) {
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.appService.base = event.url;
        this.appService.backGroundActive = (backGroundEnum[event.url] !== undefined)
          ? backGroundEnum[event.url] : backGroundEnum['/'];
      }
    });
  }
}
